import React, { useState, useEffect } from "react";
import Paper from "@mui/material/Paper";
import IconButton from "@mui/material/IconButton";
import qrIcon from "../assets/qr-scan.png";
import image from "../assets/search-2.png";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import axios from "axios";
import ErrroAlert from "./ErrorAlert";
import { getToken } from "../utils/token";
import { MenuItem, Select } from "@mui/material";

export default function AttributeSearchbar({ filterType, setFilterType, search, setSearch, onScanClick, onSubmit, fullwidth, showLocation }) {
  // const [search, setSearch] = useState([]);
  const [autoFill, setAutoFill] = useState([]);
  const [errorOpen, setErrorOpen] = useState(false);
  const [locationCount, setLocationCount] = useState(0);

  const sortTypeKey = (item) =>
    item?.type === "Artist" ? "Designer" : String(item?.type ?? "");

  const sortByTypeThenLabel = (items = []) =>
    [...items].sort((a, b) => {
      const typeCmp = sortTypeKey(a).localeCompare(sortTypeKey(b));
      if (typeCmp !== 0) return typeCmp;
      return String(a.label ?? "").localeCompare(String(b.label ?? ""));
    });

  const handelSubmit = (e) => {
    e.preventDefault();
    onSubmit(search, filterType);
  };

  const TOKEN = getToken();

  useEffect(() => {
    fetchAutofillData();
    // eslint-disable-next-line
  }, []);

  const fetchAutofillData = async () => {
    try {
      const response = await axios.get(
        `https://amal.platform.simplifii.com/api/v1/custom/mastertags?valid=1`,
        {
          headers: {
            Authorization: "Bearer " + TOKEN,
          },
        }
      );

      const data = response?.data?.response?.data;

      if (data) {
        const list = showLocation
          ? data
          : data?.filter?.((item) => item?.type !== "Location");
        setAutoFill(sortByTypeThenLabel(list || []));
      }
    } catch (e) {
      if (e && e["message"]) {
        alert(e["message"]);
      }
    }
  };

  return (
    <>
      <Paper
        component="form"
        onSubmit={handelSubmit}
        sx={{
          p: "8px 6px",
          display: "flex",
          alignItems: "center",
          width: !!fullwidth ? "100%" :{
            xs: "100%",
            sm: "80%",
            md: "50%",
          },
          padding: {
            xs: "4px 8px",
            sm: "8px 12px",
          },
          margin: "0 auto",
          borderWidth: "1px",
          borderStyle: "solid",
          borderRadius: "24px",
          borderColor: "#5f6368",
        }}
      >
        <Autocomplete
          multiple
          id="tags-outlined"
          fullWidth
          popupIcon={null}
          value={search}
          isOptionEqualToValue={(option, value) => {
            return option.id === value.id;
          }}
          options={autoFill}
          disableClearable
          onChange={(event, newValue) => {
            if (newValue[newValue.length - 1]?.type === "Location") {
              const count = newValue.filter(
                (item) => item.type === "Location"
              ).length;
              setLocationCount(count);
              if (count > 1) {
                setErrorOpen(true);
                return 
              }
            } 
            setSearch(newValue);
            
          }}
          getOptionLabel={(option) => option.label}
          // defaultValue={[top100Films[13]]}
          filterSelectedOptions
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {`${option.type === "Artist" ? "Designer" : option.type} - ${
                  option.label
                }`}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField {...params} variant="standard" placeholder="Search" />
          )}
        />
        <Select value={filterType} variant="standard">
          <MenuItem onClick={() => setFilterType("all")} value={"all"}>
            Specific
          </MenuItem>
          <MenuItem onClick={() => setFilterType("any")} value={"any"}>
            Wide
          </MenuItem>
        </Select>
        <IconButton type="submit" sx={{ p: "5px" }} aria-label="search">
          <img alt="search" className="search-icon" src={image} />
        </IconButton>
        {!!onScanClick && (
          <IconButton
            type="button"
            onClick={onScanClick}
            sx={{ p: "5px", marginLeft: { xs: "1px", sm: "5px" } }}
            aria-label="search"
          >
            <img alt="qr scanner" className="search-qr-icon" src={qrIcon} />
          </IconButton>
        )}
      </Paper>

      <ErrroAlert
        msg={`You can search for only one location. You have entered ${locationCount} locations. Please reduce the number of locations to one in search bar.`}
        open={errorOpen}
        setOpen={setErrorOpen}
      />
    </>
  );
}
